import { useTranslation } from "react-i18next"
import { useSendRequestMutation } from "../api/absenceReportApiSlice"
import CompanyClosureForm from "./CompanyClosingFrom"

function NewCompanyClosureModal({
    onSuccess = () => { }
}) {

    const [t, i18n] = useTranslation(["global", "absenceReport"])
    const [
        sendRequest, {
            isLoading: sendingIsLoading,
            isSuccess: sendingResult }
    ] = useSendRequestMutation()

    console.log("Result: " + sendingResult)

    function handleRequestSending(
        dateRange,
        reason,
        note
    ) {
        const [startDate, endDate] = dateRange

        const startEpoch = (new Date(startDate).getTime()) / 1000
        const endEpoch = (new Date(endDate).getTime()) / 1000

        console.log("Received: \n Reason:" + reason + "\n Start: " + startDate + "\n End: " + endDate)
        sendRequest({ reason, startDate: startEpoch, endDate: endEpoch, note })

    }

    const closeModal = () => { document.getElementById('closeButton').click() }

    if (sendingResult) {
        onSuccess()
        closeModal()
    }

    return (
        <>
            {
                sendingResult == true &&

                <div>
                    <div className="alert alert-success alert-dismissible" role="alert" key="unique">
                    {t("absenceReport:helper.send_success")} 
                        <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                    </div>
                </div>
            }

            <button type="button w-100" className="btn btn-primary " data-bs-toggle="modal" data-bs-target="#exampleModal">
                <a className="nav-link"> <i className="fa-solid fa-circle-plus"></i> {t("absenceReport:menu.new_company_closure")}</a>
            </button>


            <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog ">
                    <div className="modal-content bg-dark text-white">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">{t("absenceReport:menu.new_company_closure")}</h5>
                            <button type="button" className="btn-close bg-light" id="closeButton" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body text-start">
                            <CompanyClosureForm
                                onSending={handleRequestSending}
                                isLoading={sendingIsLoading} />
                        </div>
                    </div>
                </div>
            </div>




        </>

    )
}

export default NewCompanyClosureModal